// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__17rWX","file":"styles_file__1mFZY"};